import styled, { css } from 'styled-components'

export const SC_Accordian = styled.div.attrs(props => ({
  className: "accordion",
}))`
	border: 1px solid ${props => props.theme.cardBorderColor};
	padding: ${props => props.theme.gridGutterWidth};
	border-radius: ${props => props.theme.borderRadius};
`

export const SC_CardCollapse = styled.div.attrs(props => ({
  className: "collapse",
}))`

`

export const SC_Card = styled.div.attrs(props => ({
  className: "card",
}))`
	border-top: 1px solid ${props => props.theme.cardBorderColor};
	&:first-of-type {
		border-top: none;
	}
`

export const SC_CardHeader = styled.div.attrs(props => ({
  className: "card-header",
}))`
	// border-bottom: none;
	// border-top: 1px solid ${props => props.theme.cardBorderColor};
	padding-left: 0;
	padding-right: 0;
	// padding-right: ${props => parseFloat(props.theme.inputBtnFocusWidth)*1}rem;

	.btn {
		border-radius: 0;

		.icon-container {
			margin-left: ${props => props.theme.gridGutterWidth};
		}
	}
`

export const SC_CardBody = styled.div.attrs(props => ({
  className: "card-body animated fadeIn",
}))`
	padding-left: 0;
	padding-right: 0;
	padding-top: 0;
`